import { InjectionToken } from '@angular/core';
import { ModuleScope } from '@shared/interfaces/module-scope';

export const MODULE_SCOPE = new InjectionToken<ModuleScope>('MODULE_SCOPE');
